import { modalConfig, userConfig } from "../../actionTypes";

const initialState = {
  userAuthToken: "",
  showRefreshModal: false,
  // socket: null,
  // messages: [],
  // socketState: "inactive",
};

const config = (state = initialState, action) => {
  switch (action.type) {
    case userConfig.USER_TOKEN:
      const { userAuthToken } = action.payload || {};
      return {
        ...state,
        userAuthToken,
      };

    case userConfig.RESET:
      return {
        initialState,
      };

    case modalConfig.OPEN_REFRESH_MODAL:
      return {
        ...state,
        showRefreshModal: true,
      };

    case modalConfig.CLOSE_REFRESH_MODAL:
      return {
        ...state,
        showRefreshModal: false,
      };

    // case socketConfig.SET_SOCKET:
    // const socket = action.payload;
    // let messages = [...state.messages];
    // let socketState = state.socketState;
    // if (socket) {
    //   socket.addEventListener("open", (event) => {
    //     socket.send("Hello Server!");
    //     socketState = "active";
    //   });
    //   socket.addEventListener("message", (event) => {
    //     console.log("Message from server ", event.data);
    //     messages = [...messages, event.data];
    //   });
    // }
    // return {
    //   ...state,
    //   messages: messages,
    //   socketState: socketState,
    //   socket: action.payload,
    // };

    default:
      return state;
  }
};

export default config;
